<div class="panel panel-primary my-1 mx-auto rounded-3 shadow-lg" style="height: 99%">
    <div class="panel-heading clearfix">
        <div class="row">
            <div class="col-md-4"></div>
            <div class="col-md-5">
                <div class="panel-title pull-left">
                    <span style="font-size: x-large;">Acciones</span>
                </div>
            </div>
            <div class="col-md-3"></div>
        </div>
    </div>

    <!-- FILTROS -->
    <div class="m-2 p-2 rounded-3 borderFilter" style="height: 50px;">
        <!-- BUSCADOR -->
        <!-- <div class="form-group has-search" style="float: left; margin-left: 1%;">
                    <span class="fa fa-search form-control-feedback"></span>
                    <jqxInput #mySearch id="search" class="form-control" [theme]="'environment.tema'" [placeHolder]="'Buscar'"
                        (input)="findSearch()">
                    </jqxInput>
                </div> -->
        <!-- <jqxButton style="float: right; padding-top: 1px;" [theme]="environment.tema" (onClick)="clearFilters()">
            Limpiar Filtros
        </jqxButton> -->
    </div>

    <!-- TABLA GRID -->
    <div style="float: left; height: 75%; margin-top: 20px; margin-left: 30px; width: 75%;">
        <jqxGrid #myGrid style="margin: auto; margin-top: 10px;" [theme]="environment.tema" [height]="'100%'"
            [width]="'100%'" [altrows]="true" [showrowlines]="false" [showcolumnlines]="true" [source]="dataAdapter"
            [columns]="columns" [sortable]="true" [columnsresize]="true" [localization]="langGrid" [filterable]="true"
            [showfilterrow]="true" [columnsautoresize]="'true'"></jqxGrid>
    </div>
</div>

<!-- FORMULARIO -->
<jqxWindow #myWindow [width]="'90%'" [height]="300" [resizable]="false" [showCloseButton]="false"
    [theme]="environment.tema" [isModal]="false" [autoOpen]="false" [modalOpacity]="'0.01'">

    <div>Editar</div>
    <div style="overflow: hidden; padding-left: 12px; padding-right: 12px;">


        <form autocomplete="off" [formGroup]="miFormulario">
            <div>
                <div>
                    ID: <input formControlName="Id" [width]="150" [height]="23" [attr.disabled]="false"
                        placeholder="Nueva Accion">
                </div>
            </div>
            <hr>
            <div class="row mt-3">
                <!-- ID -->
                <div class="col">
                    <label class="col-sm-3 col-form-label">ID</label>
                    <input [ngClass]="{'alert-danger': inputInval('Id')}" [readonly]="disabledId" class="form-control"
                        formControlName="Id" placeholder="Introduzca el ID del Texto">
                    <span class="form-text text-danger" *ngIf="campoEsValido('Id')">
                        El Id es obligatorio*
                    </span>
                </div>
                <!-- TEXTO -->
                <div class="col">
                    <label class="col-sm-3 col-form-label">Observaciones</label>
                    <input [ngClass]="{'alert-danger': inputInval('Observaciones')}" class="form-control"
                        formControlName="Observaciones" placeholder="Introduzca las observaciones">
                    <span class="form-text text-danger" *ngIf="campoEsValido('Observaciones')">
                        Las observaciones es obligatorio*
                    </span>
                </div>
            </div>

            <!-- Botones -->
            <div style="position: absolute; bottom: 10px;">
                <jqxButton type="submit" style="margin-top: 40px; " [width]="100" [disabled]="!miFormulario.valid"
                    (onClick)="saveBtn()" [theme]="environment.tema">
                    Guardar
                </jqxButton>
                <jqxButton type=“button” style="margin-left: 10px;" [width]="100" (onClick)="cancelBtn()"
                    [theme]="environment.tema">
                    Cancelar
                </jqxButton>
            </div>
        </form>

    </div>
</jqxWindow>


<!-- CARGADOR -->
<jqxLoader #jqxLoader [text]="''" [width]="60" [height]="60" [autoOpen]="true">
</jqxLoader>